module.exports = __webpack_public_path__ + "img/40_69_011_760.20138272.jpg";